import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { hideSnackbar } from '../actions/snackbar';
import CustomSnackbar from '../components/Snackbar';

function mapStateToProps({ snackbar }) {
  return { ...snackbar };
}

class Snackbar extends PureComponent {
  render() {
    const { variant, message, isOpen } = this.props;

    return (
      <CustomSnackbar
        variant={variant}
        isOpen={isOpen}
        handleClose={this.props.hideSnackbar}
        message={message}
      />
    );
  }
}

export default connect(mapStateToProps, { hideSnackbar })(Snackbar);

Snackbar.propTypes = {
  message: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  hideSnackbar: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/containers/SnackbarContainer.js